import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useRecoilState } from 'recoil'

import Api from '@/shared/services/api'
import AuthService from '@/shared/services/auth-service'
import { userState } from '@/shared/state/user/user'

import { useAuthContext } from '../contexts/AuthContext'

export default function useProfileStartup() {
  const { userSession } = useAuthContext()
  const [userRecoilState, setUser] = useRecoilState(userState)
  const persona = AuthService.getPersona()

  const profileQuery = useQuery({
    queryKey: ['profile', userRecoilState.personaId, persona?.companyId],
    queryFn: async () => {
      const [response, error] = await Api.getPersonaProfile(
        userRecoilState.personaId
      )
      if (error) throw error
      return response.data
    },
    enabled: !!(userSession && persona?.companyId)
  })

  useEffect(() => {
    if (!profileQuery.data) return
    setUser((prevState) => ({
      ...prevState,
      ...{
        userAvatar: profileQuery.data.avatar,
        avatarName: profileQuery.data.avatarName
      }
    }))
  }, [profileQuery.data])
}
